import {
  string as yupString,
} from 'yup';

import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import InputFormik from '../../shared/forms/input/inputFormik.component';
import { required, uniqueWith } from '../../shared/forms/validators';

const schema = [
  {
    name: 'bsmAccount',
    component: InputFormik,
    meta: { label: 'BSM Account' },
    options: { yupType: yupString(), validationRules: [required], disabledWhenEditing: true },
    additionalProps: { required: true },
  },
  {
    name: 'glAccount',
    component: SelectFormik,
    meta: { label: 'GL Account', optionsKey: 'accountOptions' },
    options: { yupType: yupString(), validationRules: [required, uniqueWith(['bsmAccount'], 'Combination of BSM Account and GL Account already exists')] },
    additionalProps: { required: true },
  },
];

export default schema;
